export type ProjectRoleValue = 'READ' | 'WRITE' | 'MAINTAIN' | 'ADMIN';

export const PROJECT_ROLE_OPTIONS: Array<{ label: string; value: ProjectRoleValue }> = [
  { label: 'Read', value: 'READ' },
  { label: 'Write', value: 'WRITE' },
  { label: 'Maintain', value: 'MAINTAIN' },
  { label: 'Admin', value: 'ADMIN' },
];

export type Collaborator = {
  id: string;
  projectId: string;
  role: ProjectRoleValue;
  user: {
    id: string;
    name: string | null;
    email: string | null;
  } | null;
  team: {
    id: string;
    name: string;
  } | null;
};

export type CollaboratorsResponse = {
  collaborators: Collaborator[];
};

export const getCollaboratorKey = (collaborator: Collaborator) => {
  if (collaborator.team?.id) {
    return `team:${collaborator.team.id}`;
  }
  if (collaborator.user?.id) {
    return `user:${collaborator.user.id}`;
  }
  return `unknown:${collaborator.id}`;
};
